import { render, staticRenderFns } from "./Dashboard1.vue?vue&type=template&id=673f7938"
import script from "./Dashboard1.vue?vue&type=script&lang=js"
export * from "./Dashboard1.vue?vue&type=script&lang=js"
import style0 from "./Dashboard1.vue?vue&type=style&index=0&id=673f7938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports